import { SkeletonLine } from '@crazyegginc/hatch';

export function SkeletonChart() {
  return (
    <div className="flex w-full h-full relative">
      <SkeletonLine className="w-full !absolute bottom-0 h-full !rounded" />
    </div>
  );
}
